import axios from 'axios';

// Superuser recovery actions on a customer's login account (A-DEAD-1/3). Auth
// (admin cookie + X-App header) comes from the app's global axios defaults.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin/user-account`;

const changeEmail = (customerId, email) =>
  axios.patch(`${BASE}/${customerId}/email`, { email });

const setActive = (customerId, isActive) =>
  axios.patch(`${BASE}/${customerId}/status`, { isActive });

const AdminUserAccountService = {
  changeEmail,
  setActive,
};

export default AdminUserAccountService;
